import Equifax from "../../assets/company-logos/Equifax.png";
import FullContact from "../../assets/company-logos/FullContact.png";
import Experian from "../../assets/company-logos/Experian.png";
import Acxiom from "../../assets/company-logos/Acxiom.png";
import DataAxle from "../../assets/company-logos/dataaxle.png";
import L2 from "../../assets/company-logos/L2.png";
import Seon from "../../assets/company-logos/Seon.png";
import Accutrend from "../../assets/company-logos/Accutrend.svg";
import Infutor from "../../assets/company-logos/Infutor.png";
import Attom from "../../assets/company-logos/Attom.png";

const data = {
  usecaseInfo: {
    name: "Optimize Lead Targeting",
    description:
      "A single platform to identify, enrich, and prioritize leads across people, places, and businesses, globally.",
  },
  recipesInfo: {
    title: "Acquire more customers",
    description:
      "Identify new leads by querying Demyst's hosted files based on custom filters. Access API-ready solutions to enrich leads with firmographics, demographics, contact details (address, email, phone, etc.), property details, vehicle details, among many others.",
  },
  recipes: [
    {
      type: "Business Data",
      title: "Business Firmographics",
      description:
        "Identify industry codes, annual sales revenue, number of employees, business start year, and contact details.",
    },
    {
      type: "Business Data",
      title: "Email Leads",
      description:
        "Pulls employee contact email & role information based off employee name & name of employer.",
    },
    {
      type: "Business Data",
      title: "Business Email Screening",
      description:
        "Pulls employee and employer details and provides email risk related information for screening.",
    },
    {
      type: "People Data",
      title: "Personal Habits and Life Risks",
      description: "Gather details about an individual's lifestyle and lifestage.",
    },
    {
      type: "People Data",
      title: "Property Ownership and Occupancy",
      description:
        "Obtain occupancy status of a residence, as well as characteristics about the owner.",
    },
    {
      type: "Other Data",
      title: "...And Many More",
      description: "Access 100's of api-ready recipes.",
      ctaText: "Access Recipe Catalog",
    },
  ],

  dataPartners: {
    title: "Sample Data Providers",
    description: "Access to hundreds of data partners worldwide",
    logos: [
      {
        name: "Equifax",
        img: Equifax,
      },
      {
        name: "FullContact",
        img: FullContact,
      },
      {
        name: "Experian",
        img: Experian,
      },
      {
        name: "Acxiom",
        img: Acxiom,
      },
      {
        name: "DataAxle",
        img: DataAxle,
      },
      {
        name: "L2",
        img: L2,
      },
      {
        name: "Seon",
        img: Seon,
      },
      {
        name: "Accutrend",
        img: Accutrend,
      },
      {
        name: "Infutor",
        img: Infutor,
      },
      {
        name: "Attom",
        img: Attom,
      },
    ],
  },
  resourcesInfo: {
    title: "Resources",
    description: "The latest news, technologies, and resources from our team.",
  },
  resources: [
    {
      title: "Residential Property Data For Marketing Decisions",
      url: "https://demyst.com/blog/residential-property-data-improves-marketing-decisions",
      featured_image: "https://cdn.buttercms.com/d9kXSLsS46refWzF1wQ9",
      date: "2021-08-16",
      description:
        "Tax assessor data provides a wealth of information, including property ownership, assessed value, and property characteristics (e.g., number of floors, presence of a fireplace). However, it suffers from three major issues: ",
      more: "",
    },
  ],
};

export default data;
